import JobTemplateSecretDetails from './JobTemplateSecretDetails';

export default JobTemplateSecretDetails;
